"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    flex-grow: 1;\n    align-content: start;\n    justify-content: space-between;\n    padding: 0 0 8px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledControlsContainer = _styledComponents["default"].div(_templateObject());

var _default = StyledControlsContainer;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Calendar/styled/controlsContainer.js
// module id = 5Teb
// module chunks = 0